<template lang="pug">
w-input.f-phone( v-bind=`{ value, label }` ref='input' @input='input' )
</template>

<script lang="js">
import WInput, { mixin } from '@/widgets/w-input'

export default {
  name: 'PhoneField',
  mixins: [ mixin ],
  components: { WInput },
  props: {
    label: {
      type: String,
      default: 'username'
    },
    required: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.f-phone {

}
</style>
